import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { ErrorGlobalBoundary } from '../error/error-global-boundary';

export const PublicRoute = ({ component: Component, ...rest }: RouteProps) => {
  
  const encloseInErrorBoundary = props => (
    <ErrorGlobalBoundary>
      <Component {...props} />
    </ErrorGlobalBoundary>
  );

  if (!Component) throw new Error(`A component needs to be specified for path ${(rest as any).path}`);

  return <Route {...rest} render={encloseInErrorBoundary} />;
};

export default PublicRoute;
